export class AssignToModel {
  tblAssignToId: number = 0;
  clientId: number = 0;
  formId: string = "";
  PKTableId: number = null;
  assignToSourceTable: string = "";
  assignToUserId: string = "";
  assignTo: string = "";
  jobStartDateTime?: Date = new Date();
  expectedCompletionDateTime?: Date = new Date();
  actualCompletionDateTime?: Date;
  jobInstructions: string = "";

  isActive: boolean = true;
  isDelete: boolean = false;
  isDeactivate: boolean = false;
  createdOnUTC: Date = new Date();
  createdBy: string = "";
  updatedOnUTC: Date = new Date();
  updatedBy: string = ""; 
}

export class AssignToConfigurationModel {
  formId: string = "";
  formTitle: string = "Assign To";
  addFormName: string = "Assign To";
  editFormName: string = "Assign To";
  listReportFormName: string = "Assigment History";

  bulkAssignTo: boolean = false;
  addEditInModalPopUp: boolean = true;
  allowAdd: boolean = true;
  allowEdit: boolean = true;
  allowDelete: boolean = true;
  displayListCardView: boolean = false;
  displayContractorDropDownList: boolean = false;
  
  requiredFields: RequiredFields = new RequiredFields();
  allowedFields: AllowedFields = new AllowedFields();
  fieldsTitle: FieldsTitle = new FieldsTitle();
  templateName: string = "popup-ui";//popup-ui (e.g. leak-logic lead form) | static-ui (imvo > requests form)
  autoSave: boolean = false;
  isDisabled: boolean = false;
}
export class RequiredFields {
  jobStartDateTime: boolean = false;
  expectedCompletionDateTime: boolean = false;
  actualCompletionDateTime: boolean = false;
  jobInstructions: boolean = false;
}

export class AllowedFields {
  jobStartDateTime: boolean = true;
  expectedCompletionDateTime: boolean = true;
  actualCompletionDateTime: boolean = true;
  jobInstructions: boolean = true;
}
export class FieldsTitle {
  jobStartDateTime: string = "Job Start Date";
  expectedCompletionDateTime: string = "Expected Completion Date";
  actualCompletionDateTime: string = "Actual Completion Date";
  jobInstructions: string = "Job Instructions";
}
export class ValidationModel {

  isAssignToValid: boolean = true;
  assignToValidationMessage: string = "Please select Assign To";

  isJobStartDateTimeValid: boolean = true;
  jobStartDateTimeValidationMessage: string = "Job Start Date is required";

  isExpectedCompletionDateTimeValid: boolean = true;
  expectedCompletionDateTimeValidationMessage: string = "Expected Completion Date is required";

  isActualCompletionDateTimeValid: boolean = true;
  actualCompletionDateTimeValidationMessage: string = "Actual Completion Date is required";

  isJobInstructionsValid: boolean = true;
  jobInstructionsValidationMessage: string = "Job Instructions required";
  
}
